import { addModal } from 'modules/messageSystem/actions/addModal';
import { updateAppointment } from 'modules/appointmentInfo/actions/updateAppointment';
import { isCurrentAppointmentOngoing } from 'modules/appointmentInfo/selectors/currentAppointment';
import {
  MODAL_CANCEL_APPOINTMENT,
  MODAL_UNABLE_TO_CANCEL_APPOINTMENT,
} from 'modules/messageSystem/constants/modalCodes';

export const cancelAppointment = () => (dispatch, getState) => {
  const state = getState();
  const { currentAppointment } = state.appointmentInfo;

  return isCurrentAppointmentOngoing(state)
    ? dispatch(addModal({
      testId: 'close-appointment-modal',
      typeId: MODAL_UNABLE_TO_CANCEL_APPOINTMENT,
    }))
    : dispatch(addModal({
      testId: 'close-appointment-modal',
      typeId: MODAL_CANCEL_APPOINTMENT,
      onOk: () => dispatch(updateAppointment({
        appointmentId: currentAppointment.appointmentId,
        status: 'CANCELED',
      })),
      preventClosingWhenDismiss: true,
    }));
};
